import fileSaver from 'file-saver';

export default fileSaver;
